<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 70% !important; height: 95% !important;">
      <header class="modal-card-head hero is-dark">
        <div class="columns">
          <div class="column is-">
            <div class="logo">
              <img width="20%" src="@/assets/logo2.png" alt="Logo"/>
            </div>
          </div>
        </div>
        <div class="hero-body" style="padding: 1rem;">
          <div class="container has-text-centered">
            <h1 class="title has-text-white is-2">Consentimiento</h1>
          </div>
        </div>
      </header>
      <section class="modal-card-body">
        <div style="margin-left: 75px; margin-right: 75px; padding-top: 60px">
          <span style="white-space: pre-line">
          {{ isBoss ? consentimiento.lider.Lider : consentimiento.colaboradores.Colaborador }}
        </span>
          <br/>
          <h2 class="title is-7">
            {{ isBoss ? consentimiento.lider.parrafo4 : consentimiento.colaboradores.parrafo4 }}
          </h2>
          <div style="padding-top: 5%;">
            <label class="checkbox">
              <input type="checkbox" v-model="agree" name="acept" id="acept">
              Acepto el Consentimiento informado
            </label>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
            v-show="agree"
            @click="next()"
            class="button is-dark"
            :disabled="!agree"
        >
          Aceptar
        </button>
        <button
            v-show="!agree"
            @click="endno()"
            class="button is-is-dark"
        >
          Terminar y Guardar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import json from "../lideres/infoEncuesta.json";

export default {
  data() {
    return {
      consentimiento: json.consentimiento,
      agree: this.isAgree
    }
  },
  props: {
    show: Boolean,
    isBoss: Boolean,
    isAgree: Boolean
  },
  methods: {
    next() {
      this.$emit("aceptConsent", this.agree);
    },
    endno() {
      this.$emit("endno");
    }
  },
  created() {
  },
  watch: {}
}
</script>

<style>
textarea {
  resize: none;
  overflow: hidden;
  box-shadow: inset 0 0px 0px rgb(10 10 10 / 10%);
}

.inputP {
  height: 50px !important;
  font-size: 40px !important;
  width: 100% !important;
  padding-left: 0px !important;
  box-shadow: inset 0 0px 0px rgb(10 10 10 / 10%) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/modals/ModalConsentimiento.vue